module.exports = __webpack_public_path__ + "img/POP-00008-1.b2f7745b.png";